


















































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbShopAccount,TbShop,TbTransferOrder } from '@/http';
import { dialogPanel,logoutPanel,calendarPanel } from "@/components"
import dayjs from 'dayjs';
import { Toast } from 'vant';
@Component({ 
    components: {
        dialogPanel,logoutPanel,calendarPanel
    },
})
export default class inallot extends Vue {
   
    public $refs: {
    };
    /**查询项 */
    searchValue={
        outShopId:'',
        transferStatus:null,
        start:'',
        end:'',
        skip:0,
        count:10,
    }
    /**接收门店下拉 */
    showShopnamePopover = false;
    shopOptions=[]
    /**状态下拉 */
    showStatusPopover = false;
    statusOptions=[
        {
            label:"全部状态",
            value:null,
        },
        {
            label:"待接收",
            value:1,
        },
        {
            label:"已接收",
            value:2,
        },
    ]
    /**时间控件 */
    pickerShow = false;
    startDate="";
    endDate="";

    userInfo:any={};

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    total=0;
    currentPage=1
    totalStock=0;

   
    showRolePopover = false;

    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=1;
    tipType=1;
    deletId="";

    isDeleting = false;
    
    

    created() {
        
    }

    async mounted(){
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
        await this.getshopList();
    }

    /**门店下拉选中信息 */
    get getShopname(){
        let str = ""
        if(this.searchValue.outShopId){
            str = this.shopOptions.findIndex(v=>v.id==this.searchValue.outShopId)>-1?this.shopOptions.find(v=>v.id==this.searchValue.outShopId).shopName:'';
        }else{
            str ='全部调出门店'
        }
        return str;
    }
    /**调拨状态 */
    get getStatus(){
        let str = ""
        switch (this.searchValue.transferStatus) {
            case null:
                str="全部状态"
                break;
            case 1:
                str="待接收"
                break;
            case 2:
                str="已接收"
                break;
            default:
                break;
        }
        return str;
    }
    /**下拉刷新 */
    onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.list = [];
      this.searchValue.skip=0;
      this.searchValue.count=10;
      this.total = 0;
      this.currentPage = 1;
      this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
        setTimeout(async() => {
            if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
            }
            let s = this.searchValue.count;
            let res = await TbTransferOrder.GetTbTransferOrderListV2(Object.assign({},this.searchValue,{
                receiveShopId:this.userInfo.shopId
            }));
            this.list = this.searchValue.skip==0? res.items:this.list.concat(res.items);
            this.total  = res.totalCount;
            this.currentPage++;
            this.searchValue.skip = (this.currentPage - 1) * s;
            this.loading = false;
            if (this.list.length >= this.total) {
                this.finished = true;
                console.log('list',this.list);
            }
        }, 1000);
    }
    /**获取商品列表 */
    async getList(){
        this.onRefresh();
    }
    /**获取门店下拉 */
    async getshopList(){
        let res= await TbShop.GetTbShoppListForSwitch({
            shopId:this.userInfo.shopId,
        })
        this.shopOptions = res.filter(v=>v.isUpdate==true && v.id!=this.userInfo.shopId);
        console.log('this.shopOptions',this.shopOptions);
    }
    /**选择全部门店 */
    async changeStatusAll(){
        this.searchValue.outShopId = "";
        this.showShopnamePopover = false;
        await this.getList();
    }
    /**选择门店id */
    async changeShopXL(item){
        this.searchValue.outShopId = item.id;
        this.showShopnamePopover = false;
        await this.getList();
    }
    /**选择调拨状态 */
    async changeStatusXL(item){
        this.searchValue.transferStatus = item.value;
        this.showStatusPopover = false;
        await this.getList();
    }
    
    /**重置 */
    async resetSearch(){
        this.searchValue={
            outShopId:'',
            transferStatus:null,
            start:'',
            end:'',
            skip:0,
            count:10,
        }
        this.startDate = "";
        this.endDate = "";
        this.showShopnamePopover = false;
        this.showStatusPopover = false;
        await this.getList();
    }
    openselDate() {
        this.pickerShow = true;
    }
    /**确定选择时间 */
    async onselConfirm(date){
        const [start, end] = date;
        this.startDate = dayjs(start).format("YYYY-MM-DD");
        this.endDate = dayjs(end).format("YYYY-MM-DD");
        this.searchValue.start = dayjs(start).format("YYYY-MM-DD") + " " + "00:00:00";
        this.searchValue.end = dayjs(end).format("YYYY-MM-DD") + " " + "23:59:59";
        this.pickerShow = false;
        await this.getList();
    }
    closeTime(){
        this.pickerShow = false;
    }
    /**提示弹窗 */
    async tipConfirm(){
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }
    viewDetail(item){
        console.log('item',item);
        this.$router.push(`/pad/allot/viewAllot?id=${item.id}&&allotactive=2`);
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/allot/components/inallot.vue